import * as React from 'react';
import { shallowEqual } from 'react-redux';
import { Contact } from '../../../sic-lib/types/Contact';
import { useAppSelector } from '../../../store/hooks';
import ComposeEmail from '../Communicator/ComposeEmail/ComposeEmail';

interface Props {
    contact: Contact;
    subject: string;
}

export default function EmailThreadReply({ contact, subject }: Props) {
    const store = useAppSelector(state => {
        return {
            contactRefEmail: state.contact?.emailThreadDrawer?.contactReferenceEmail || '',
            clientHasUserWithDialer: state.user?.clientHasUsersWithDialer || false,
        };
    }, shallowEqual);

    const fieldId = React.useMemo(() => {
        return contact.values.find(value => value.value === store.contactRefEmail)?.fieldId || NaN;
    }, [contact.values, store.contactRefEmail]);

    return (
        <>
            <ComposeEmail
                contactId={contact.contactId}
                clientFieldId={fieldId}
                consent={contact.consent}
                subject={subject}
                userWithDialer={store.clientHasUserWithDialer}
            />
        </>
        // <></>
    );
}
